
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate",
      function () {
        return require("private-next-pages/affiliate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate"])
      });
    }
  